import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { OrderQuoteDTO } from '../interfaces/order-quote';
import { OrderCreatedResponseDTO } from '../interfaces/order-created-response';
import { QuoteVehicleDTO } from '../interfaces/quote-vehicle';
import { QuoteAddressDTO } from '../interfaces/quote-address';
import { PaymentIntentResponseDTO } from '../interfaces/stripe';
import { OrderQuoteConfirmationDTO } from '../interfaces/order-quote-confirmation';

@Injectable({ providedIn: 'root' })
export class OrderQuoteService {
  private orderQuoteURL = '/api/order-quote';
  private orderQuoteAddressURL = '/api/orderQuoteAddress';

  constructor(private http: HttpClient, private authService: AuthService) {}

  getAllowedTaskTypesForAPICustomer(): Promise<number[]> {
    let options = { headers: {} };
    return this.http.get<number[]>('/api/organisation/taskTypes/allowed', options).toPromise();
  }

  generateQuote(quoteGuid: string): Promise<OrderQuoteDTO> {
    return this.http.get(`${this.orderQuoteURL}/generate/${quoteGuid}`).toPromise();
  }

  patchQuote(quoteGuid: string, patch): Promise<OrderQuoteDTO> {
    if (patch.length > 0) {
      return this.http.patch(`${this.orderQuoteURL}/${quoteGuid}`, patch).toPromise();
    }

    return Promise.resolve(null);
  }

  createQuoteAddress(quoteGuid: string, quoteAddress: QuoteAddressDTO): Promise<OrderQuoteDTO> {
    return this.http.post(`${this.orderQuoteURL}/${quoteGuid}`, quoteAddress).toPromise();
  }

  patchQuoteAddress(quoteGuid: string, quoteAddressId: number, patch): Promise<OrderQuoteDTO> {
    return this.http
      .patch(`${this.orderQuoteURL}/${quoteGuid}/address/${quoteAddressId}`, patch)
      .toPromise();
  }

  vrmLookup(vrm): Promise<QuoteVehicleDTO> {
    return this.http.get<QuoteVehicleDTO>(`${this.orderQuoteURL}/vrm-lookup/${vrm}`).toPromise();
  }

  bookOrder(quoteDTO: OrderQuoteDTO): Promise<OrderCreatedResponseDTO> {
    console.log('QD ', quoteDTO);
    return this.http
      .post<OrderCreatedResponseDTO>(`${this.orderQuoteURL}/${quoteDTO.quoteGuid}/book/`, quoteDTO)
      .toPromise();
  }

  paymentMade(quoteGuid: string, paymentIntentId: string): Promise<OrderCreatedResponseDTO> {
    return this.http
      .get<OrderCreatedResponseDTO>(
        `${this.orderQuoteURL}/${quoteGuid}/paymentMade/${paymentIntentId}`,
      )
      .toPromise();
  }

  createPaymentIntent(quoteGuid: string) {
    return this.http
      .post<PaymentIntentResponseDTO>(
        `${this.orderQuoteURL}/${quoteGuid}/create-payment-intent`,
        {},
      )
      .toPromise();
  }

  initializeQuote(quote: OrderQuoteDTO): Promise<OrderQuoteDTO> {
    const url = this.orderQuoteURL + '/initialize';

    return this.http.post<OrderQuoteDTO>(url, quote).toPromise();
  }

  getOrderQuoteConfirmation(quoteGuid: string): Promise<OrderQuoteConfirmationDTO> {
    return this.http
      .get<OrderQuoteConfirmationDTO>(`${this.orderQuoteURL}/confirmation/${quoteGuid}`)
      .toPromise();
  }
}
